<template lang='pug'>
  b-row
    b-col(xs='12')
      b-card
        div(slot="header")
          b-row
            b-col(xs='10')
              strong {{ tableTitle }}
              small.pl-2 Collection
            c-create-entity(
              :entity='entity'
              :newEntityBtn='newEntityBtn'
              :newEntityRouteName='newEntityRouteName'
            )
        c-index-table(
          :fields='fields'
        )
</template>

<script>
  import cIndexTable from '@/components/Shared/IndexTable.vue'
  import cCreateEntity from '@/components/Shared/CreateEntity.vue'

  export default {
    name: 'ProjectIndex',
    components: { cIndexTable, cCreateEntity },
    data: () => {
      return {
        entity: 'project',
        tableTitle: 'Projects',
        newEntityBtn: 'New project',
        newEntityRouteName: 'New project',
        fields: {
          id: { label: 'ID' },
          type: { label: 'Type' },
          name: { label: 'Name', sortable: true },
          relatedStructures: { label: 'Objects' },
          actions: { label: 'Actions' }
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Project/Index.vue